export const calculateTaxes = function (amount, taxRate) {
    /** tax is stored as a integer Value between 1 and 100 */
    let taxFactor = taxRate / 100;
    let tax = Math.round((amount * taxFactor + Number.EPSILON) * 100) / 100;
    return {
        netPrice: amount,
        totalPrice: amount + tax,
        tax,
        taxRate,
    };
};
